export const Modal = ({ 
    isOpen, 
    onClose, 
    title, 
    children, 
    footer, 
    size = 512, // Default width in pixels
    maxHeight = null, // Default max height in pixels
    showCloseButton = true,
    className = "",
    headerIcon = null,
    subtitle = null
}) => {
    if (!isOpen) return null;

    const modalStyle = {
        maxWidth: `${size}px`,
        maxHeight: maxHeight ? `${maxHeight}px` : 'max-h-[85vh]'
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div 
                className={`bg-white rounded-xl shadow-2xl w-full px-4 py-2 flex flex-col ${className}`}
                style={modalStyle}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <div className="flex items-center gap-4">
                        {headerIcon && (
                            <div className="bg-[--color-primary]/10 rounded-full p-3">
                                {headerIcon}
                            </div>
                        )}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
                            {subtitle && (
                                <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
                            )}
                        </div>
                    </div>
                    {showCloseButton && (
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                            type="button"
                        >
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>
                
                {/* Content */}
                <div className="flex-1 p-4">
                    {children}
                </div>
                
                {/* Footer */}
                {footer && (
                    <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;